module.exports = __webpack_public_path__ + "img/cf.71f4d2ad.svg";